import { useAuth } from '../../contexts/AuthContext';
import { useI18n } from '../../contexts/I18nContext';
import { Dialog } from '../ui/Dialog';
import { LoadingStatus } from '../ui/LoadingFeedback';
import { defaultMessageTemplate } from './messageText';
import { MessageTemplateEditor } from './MessageTemplateEditor';
import { useMessageTemplate } from './useMessageTemplate';

function SettingsContent({ sender, onClose }: { sender: string; onClose: () => void }) {
  const { t, language } = useI18n();
  const settings = useMessageTemplate();
  return (
    <div className="overflow-y-auto p-5 sm:p-6">
      {settings.loading ? (
        <LoadingStatus label={t('message.loading')} />
      ) : settings.error ? (
        <div role="alert" className="space-y-3">
          <p>{t('message.loadFailed')}</p>
          <button type="button" className="btn-secondary min-h-11" onClick={settings.retry}>
            {t('message.retry')}
          </button>
        </div>
      ) : (
        <MessageTemplateEditor
          sender={sender}
          initialValue={settings.template || defaultMessageTemplate(language, sender)}
          onSave={settings.save}
          onCancel={onClose}
        />
      )}
    </div>
  );
}

export function PersonalMessageSettings({ onClose }: { onClose: () => void }) {
  const { user } = useAuth();
  const { t } = useI18n();
  if (!user) return null;
  return (
    <Dialog isOpen onClose={onClose} title={t('message.settings')} className="max-w-xl">
      <SettingsContent key={user.id} sender={user.name || ''} onClose={onClose} />
    </Dialog>
  );
}
